module.exports = __webpack_public_path__ + "load-testing.NM6EDyH4.svg";